import { LearningVideo } from "../../../../components/LearningVideo/index.jsx";
import { getGuideDisplayName } from "../../../../shared/guideNames.js";
import React, { useState, useRef, useEffect } from "react";
import { renderBloco } from "./RenderBlock";
import {
  BRAND,
  BTN_PRIMARY,
  BTN_SECONDARY,
  BUTTON_RESET,
  CARD,
} from "../../../../styles";
import { normalizeVideoEmbedUrl } from "../../../../shared/utils";
import { Breadcrumb } from "../../../../components/BreadCrump";
import { Badge } from "../../../../components/Badge";
import { ReportProblem } from "./ReportProblem";
import { ImageExpanded } from "./ImageExpanded";
import { isAulaConcluida, isGuiaConcluida } from "../progressUtils";
export function LessonView(props) {
  var value;
  let aula = props.aula;
  let carregandoConteudo = props.carregandoConteudo;
  let curso = props.curso;
  let categoria = props.categoria;
  let modulo = props.modulo;
  let progress = props.progress;
  let studentId = props.studentId;
  let onConcluir = props.onConcluir;
  let onVoltar = props.onVoltar;
  let onAnterior = props.onAnterior;
  let onProxima = props.onProxima;
  let onOpenCurso = props.onOpenCurso;
  let onOpenCategoria = props.onOpenCategoria;
  let onReportarErro = props.onReportarErro;
  const tabPadding = "clamp(8px, 2.2vw, 12px)";
  const compactMargin = "clamp(10px, 2.8vw, 14px)";
  const [isMobileViewport, setIsMobileViewport] = useState(
    "undefined" !== typeof window && window.innerWidth <= 480,
  );
  const mobileBleedPx = isMobileViewport ? 8 : 0;
  const [guiaId, setGuiaId] = useState(aula.guias[0]?.id || null);
  const [reportOpen, setReportOpen] = useState(false);
  const [imagemExpandida, setImagemExpandida] = useState(null);
  const topRef = useRef(null);
  const concluida = isAulaConcluida(progress, aula);
  const guiaAtual =
    aula.guias.find((itemId) => itemId.id === guiaId) || aula.guias[0];
  const guiaAtualConcluida = guiaAtual
    ? isGuiaConcluida(progress, aula.id, guiaAtual.id)
    : concluida;
  const videoSrc = normalizeVideoEmbedUrl(aula.videoUrl);
  const handleOpenImage = (imageUrl) => {
    if (imageUrl) {
      setImagemExpandida(imageUrl);
    }
  };
  useEffect(() => {
    const onResize = () => {
      setIsMobileViewport(window.innerWidth <= 480);
    };
    onResize();
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);
  useEffect(() => {
    setGuiaId(aula.guias[0]?.id || null);
    setReportOpen(false);
    setImagemExpandida(null);
  }, [aula.id]);
  return (
    <div
      style={{
        maxWidth: "none",
        margin: "0 auto",
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: "clamp(20px, 5vw, 36px)",
      }}
    >
      {reportOpen && (
        <ReportProblem
          reportOpen={reportOpen}
          setReportOpen={setReportOpen}
          onReportarErro={onReportarErro}
        />
      )}
      <div ref={topRef} />
      <Breadcrumb
        onHome={onVoltar}
        items={[
          categoria
            ? {
                label: categoria.nome,
                onClick: onOpenCategoria,
              }
            : null,
          {
            label: curso.nome,
            onClick: onOpenCurso,
          },
          {
            label: modulo.nome,
          },
        ].filter(Boolean)}
      />
      <div
        style={{
          ...CARD,
          overflow: "hidden",
          marginBottom: compactMargin,
        }}
      >
        {videoSrc ? (
          <div
            style={{
              background: "#000",
            }}
          >
            <div
              style={{
                position: "relative",
                paddingTop: "56.25%",
              }}
            >
              <LearningVideo
                src={videoSrc}
                contextKey={[
                  "conteudo",
                  studentId,
                  aula.id,
                  "video",
                  "principal",
                ].join(":")}
                title={aula.titulo}
                allow={
                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                }
                allowFullScreen={true}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              height: 56,
              background: "linear-gradient(135deg,#153543,#1F4754)",
              color: "rgba(255,255,255,.6)",
              display: "grid",
              placeItems: "center",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {"Aula sem video"}
          </div>
        )}
        <div
          style={{
            padding: "clamp(4px, 1vw, 10px)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "clamp(8px, 2.2vw, 12px)",
              alignItems: "flex-start",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 800,
                  color: "#64748B",
                  marginBottom: 6,
                }}
              >
                {curso.nome}
                {" - "}
                {modulo.nome}
              </div>
              <h2
                style={{
                  margin: 0,
                  color: "#17212B",
                  fontSize: 23,
                  lineHeight: 1.2,
                }}
              >
                {aula.titulo}
              </h2>
            </div>
            {concluida && <Badge color={BRAND}>{"Concluida"}</Badge>}
          </div>
          {aula.guias.length > 0 && (
            <div
              style={{
                marginTop: "clamp(12px, 3vw, 18px)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 6,
                  flexWrap: "wrap",
                  marginBottom: "clamp(8px, 2.2vw, 12px)",
                }}
              >
                {aula.guias.map((guia) => {
                  const ativa = guiaAtual?.id === guia.id;
                  const guiaConcluida = isGuiaConcluida(
                    progress,
                    aula.id,
                    guia.id,
                  );
                  return (
                    <button
                      onClick={() => setGuiaId(guia.id)}
                      style={{
                        ...BUTTON_RESET,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        background: ativa
                          ? BRAND
                          : guiaConcluida
                            ? "#E7FAF6"
                            : "#F4F7F9",
                        color: ativa
                          ? "#FFF"
                          : guiaConcluida
                            ? "#0F766E"
                            : "#526273",
                        border:
                          !ativa && guiaConcluida
                            ? "1px solid #9BE1D3"
                            : "1px solid transparent",
                        borderRadius: 10,
                        padding: "".concat(tabPadding, " ").concat(tabPadding),
                        fontSize: 12,
                        fontWeight: 800,
                      }}
                      key={guia.id}
                    >
                      {guiaConcluida && <span aria-hidden={true}>{"✓"}</span>}
                      {getGuideDisplayName(guia.nome)}
                    </button>
                  );
                })}
              </div>
              <div
                style={{
                  border: "1px solid #E7EEF2",
                  borderRadius: 14,
                  background: "#FFF",
                }}
              >
                {!(
                  null !== guiaAtual &&
                  undefined !== guiaAtual &&
                  null !== (value = guiaAtual.blocos) &&
                  undefined !== value &&
                  value.length
                ) && (
                  <div
                    style={{
                      color: "#94A3B8",
                      fontSize: 13,
                    }}
                  >
                    {carregandoConteudo
                      ? "Carregando conteudo..."
                      : "Sem conteudo."}
                  </div>
                )}
                <div
                  style={{
                    display: "grid",
                    gap: "clamp(10px, 2.5vw, 16px)",
                  }}
                >
                  {(guiaAtual?.blocos || []).map((bloco) => (
                    <div key={bloco.id}>
                      {renderBloco(bloco, {
                        onImageClick: handleOpenImage,
                        studentId,
                        aulaId: aula.id,
                        guiaId: guiaAtual?.id,
                        guiaNome: guiaAtual?.nome,
                      })}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          ...CARD,
          padding: "clamp(10px, 2.6vw, 16px)",
          marginBottom: compactMargin,
        }}
      >
        <div
          style={{
            display: "grid",
            gap: "clamp(8px, 2.2vw, 10px)",
          }}
        >
          <button
            onClick={() => onConcluir(guiaAtual?.id || null)}
            style={{
              ...BUTTON_RESET,
              width: "100%",
              borderRadius: 12,
              padding: "clamp(10px, 2.5vw, 12px) clamp(12px, 2.8vw, 14px)",
              fontSize: 13,
              fontWeight: 900,
              background: guiaAtualConcluida ? "#E7FAF6" : "#F7FAFB",
              border: "1px solid ".concat(
                guiaAtualConcluida ? "#9BE1D3" : "#DCE6EB",
              ),
              color: guiaAtualConcluida ? "#0F766E" : "#526273",
            }}
          >
            {guiaAtualConcluida
              ? guiaAtual
                ? "".concat(getGuideDisplayName(guiaAtual.nome), " concluido")
                : "Aula concluida"
              : guiaAtual
                ? "Marcar ".concat(
                    getGuideDisplayName(guiaAtual.nome),
                    " como concluido",
                  )
                : "Marcar como concluida"}
          </button>
          <button
            onClick={() => setReportOpen(true)}
            style={{
              ...BUTTON_RESET,
              width: "100%",
              borderRadius: 12,
              padding: "clamp(10px, 2.4vw, 11px) clamp(12px, 2.8vw, 14px)",
              fontSize: 13,
              fontWeight: 800,
              background: "#FFF5F5",
              border: "1px solid #FECACA",
              color: "#DC2626",
            }}
          >
            {"Reportar problema"}
          </button>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            onAnterior && onProxima
              ? "1fr 1fr 1fr"
              : onAnterior || onProxima
                ? "1fr 1fr"
                : "1fr",
          gap: "clamp(6px, 1.8vw, 8px)",
        }}
      >
        {onAnterior && (
          <button
            onClick={onAnterior}
            style={{
              ...BTN_SECONDARY,
              width: "100%",
            }}
          >
            {"Anterior"}
          </button>
        )}
        <button
          onClick={onVoltar}
          style={{
            ...BTN_SECONDARY,
            width: "100%",
          }}
        >
          {"Lista do curso"}
        </button>
        {onProxima && (
          <button
            onClick={onProxima}
            style={{
              ...BTN_PRIMARY,
              width: "100%",
            }}
          >
            {"Proxima aula"}
          </button>
        )}
      </div>
      <div
        style={{
          textAlign: "center",
          marginTop: compactMargin,
        }}
      >
        <button
          onClick={() => {
            var current;
            return null === (current = topRef.current) || undefined === current
              ? undefined
              : current.scrollIntoView({
                  behavior: "smooth",
                });
          }}
          style={{
            ...BUTTON_RESET,
            background: "rgba(255,255,255,.08)",
            borderRadius: 999,
            color: "rgba(255,255,255,.62)",
            padding: "7px 14px",
            fontSize: 11,
            fontWeight: 700,
          }}
        >
          {"Voltar ao topo"}
        </button>
      </div>
      {imagemExpandida && (
        <ImageExpanded
          src={imagemExpandida}
          open={Boolean(imagemExpandida)}
          onClose={() => setImagemExpandida(null)}
        />
      )}
    </div>
  );
}
